export const baseUrl = "";
export const recaptchaSiteKey = "6Le1NkstAAAAANznwq0a4VoqTKrKHtycsCpKsWFu";
